/**
 * Pagination dots for the testimonials scroll-snap track.
 *
 * Replaces the Swiper `pagination` module of app/components/blocks/
 * BlockTestimonials.vue — the track itself is plain CSS scroll-snap, so
 * swiping works with this file absent; only the dots need JS.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.hasAttribute('data-testimonials-ready')) {
      return;
    }

    var track = root.querySelector('[data-testimonials-track]');
    var pagination = root.querySelector('[data-testimonials-pagination]');
    if (!track || !pagination) {
      return;
    }

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-testimonials-slide]'));
    if (slides.length < 2) {
      return;
    }

    root.setAttribute('data-testimonials-ready', 'true');
    pagination.innerHTML = '';

    var bullets = slides.map(function (slide, index) {
      var bullet = document.createElement('button');
      bullet.type = 'button';
      bullet.className = 'block-testimonials__bullet';
      bullet.setAttribute('aria-label', 'Go to testimonial ' + (index + 1));
      bullet.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      pagination.appendChild(bullet);
      return bullet;
    });

    pagination.hidden = false;

    function activeIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var slideCenter = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });
      return best;
    }

    function sync() {
      var current = activeIndex();
      bullets.forEach(function (bullet, index) {
        bullet.classList.toggle('is-active', index === current);
        bullet.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
    }

    var frame = null;
    track.addEventListener(
      'scroll',
      function () {
        if (frame) {
          return;
        }
        frame = window.requestAnimationFrame(function () {
          frame = null;
          sync();
        });
      },
      { passive: true }
    );

    sync();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.forEach.call(container.querySelectorAll('[data-testimonials]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
